import { render, staticRenderFns } from "./activationDetails.vue?vue&type=template&id=4f19fc1c&scoped=true&"
import script from "./activationDetails.vue?vue&type=script&lang=js&"
export * from "./activationDetails.vue?vue&type=script&lang=js&"
import style0 from "./activationDetails.vue?vue&type=style&index=0&id=4f19fc1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19fc1c",
  null
  
)

export default component.exports